import userRoutes from './user'
import accountRoutes from './account'
import servicesRoutes from './services'
import attachmentRoutes from './attachments'
import bankAccountsRoutes from './bankAccounts'
import contactsRoutes from './contacts'
import dashboardRoutes from './dashboard'
import settingRoutes from './settings'

export default [
  ...bankAccountsRoutes,
  ...contactsRoutes,
  ...attachmentRoutes,
  ...servicesRoutes,
  ...userRoutes,
  ...dashboardRoutes,
  ...settingRoutes,
  ...accountRoutes
]



// WEBPACK FOOTER //
// ./src/routes/index.js